<template>
  <ClaimIndex :claims="claims" />
</template>
<script>
import ClaimIndex from "@/components/claim/ClaimIndex.vue";
import { mapActions } from "vuex";
import { toCamelCase } from "@/utils/utils.js";

export default {
  components: {
    ClaimIndex,
  },

  data() {
    return {
      claims: [],
    };
  },

  mounted() {
    this.getClaims();
  },

  methods: {
    ...mapActions("claims", ["fetchIndex"]),

    async getClaims() {
      const response = await this.fetchIndex({ page: 1, includes: ["claim_product"] });
      if (response?.success) this.claims = toCamelCase(response.data.claims);
    },
  },
};
</script>
